// extracted by mini-css-extract-plugin
module.exports = {"Barcode":"Barcode_Barcode__f8qtI","CountDown":"Barcode_CountDown__2W8oS","CountDownText":"Barcode_CountDownText__1GlzA"};